import { connect } from 'react-redux';
import GenericLoader from '../util/GenericLoader';
import { fetchStagingAction, fetchStagingFieldsAction } from '../../redux/actions/staging';

const mapDispatchToProps =
  (fetchFunc) =>
  (dispatch, { buildingId }) => ({
    fetchFunction: () => {
      if (buildingId) dispatch(fetchFunc(buildingId));
    },
  });

export default connect(null, mapDispatchToProps(fetchStagingAction))(GenericLoader);

export const StagingFieldsLoader = connect(
  null,
  mapDispatchToProps(fetchStagingFieldsAction)
)(GenericLoader);
